import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as searchActions from './search-actions';
import * as productActions from '../product-list/list-actions';
import * as routerSelectors from '../../../route/router-state.selectors';
import * as searchSelectors from '../../../products/state/product-search/search-selectors';
import * as locationSelectors from '../../../locations/state/locations-selectors';
import { mergeMap, switchMap, takeUntil, tap, withLatestFrom } from 'rxjs/operators';
import { of } from "rxjs";
import { Store } from "@ngrx/store";
import { _seoContent } from "@app/marketplace/seo-content/utils";
import { Router } from "@angular/router";
import {ProductProviderEnum} from '@app/marketplace/core/enum/productProvider';
import {environment} from '@env/environment.dev';

@Injectable()
export class SearchEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private store: Store<any>) { }

  searhProducts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(searchActions.SEARCH_PRODUCTS, searchActions.CANCEL_SEARCH_REQUEST),
      withLatestFrom(
        this.store.select(routerSelectors.getMergedRoute),
        this.store.select(locationSelectors.selectLocation),
        this.store.select(searchSelectors.selectTerm),
        this.store.select(searchSelectors.selectProvider),
        (action: any, router: any, location:any, term:any,provider:any) => {
          if (provider == ProductProviderEnum.Shein && !environment.turn_on_shein) {
            provider = ProductProviderEnum.Internal;
          }
          return {
            action,
            payload: action.payload,
            url: router.url,
            location:{type:location.locationType,codes:location.locations},
            term:term.searhTerm,
            provider:provider
          }
        }
      ),
      tap((data: any) => {
        //if(!data.url.startsWith('/market/productos-compras-cuba-online'))
          this.router.navigate(['/market/productos-compras-cuba-online']);
      }),
      mergeMap((data: any) => {
        if (data.action.type == searchActions.SEARCH_PRODUCTS) {
          let payload = {
            provider:data.provider,
            pageIndex: 1,
            pageSize: 12,
            pagingStrategy: 0,
            locationType:data.location.codes.length > 0? data.location.type:0,
            locations: data.location.codes.length > 0? data.location.codes:null,
            locationResolver: false,
            filter: {
              searchTerms: data.term,
              sortingArgs: 0,
              categories: null,
              priceRange: {
                low: 1,
                high: 1000,
              },
            },
            categoryCode: '',
            supplierCode: ''
          };
          //console.info(payload);
          return [
            { type: productActions.LOADING_PRODUCTS, payload}
          ];
        }
        else return [{ type: searchActions.SEARCH_PRODUCTS_FAILURE}];
      })
    )
  );
}
